import StaticPage from '../components/StaticPage';

export default function AccessibilityPage() {
  return (
    <StaticPage title="Accessibility" updated="June 30, 2026">
      <p>halfprice.ca is committed to making our platform accessible to everyone, including people with disabilities, in accordance with the Accessibility for Manitobans Act (AMA) and general web accessibility best practices.</p>

      <h2>Our Commitment</h2>
      <p>We aim to meet Web Content Accessibility Guidelines (WCAG) 2.1 Level AA standards across the platform, including:</p>
      <ul>
        <li>Sufficient colour contrast for text readability</li>
        <li>Keyboard navigability for all interactive elements</li>
        <li>Descriptive alt text for meaningful images</li>
        <li>Clear, consistent navigation and page structure</li>
        <li>Mobile-friendly, responsive design that works across devices</li>
      </ul>

      <h2>Ongoing Work</h2>
      <p>Accessibility is an ongoing process. As halfprice.ca grows, we continue to test and improve the platform's accessibility. If you encounter any barrier while using halfprice.ca, we want to know about it.</p>

      <h2>Feedback</h2>
      <p>If you experience any difficulty accessing content or features on halfprice.ca, please contact us at <a href="mailto:hello@halfprice.ca">hello@halfprice.ca</a> and describe the issue. We will work to address it as quickly as possible.</p>
    </StaticPage>
  );
}
